import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { PROD_API_URL, DEV_API_URL } from './global-vars';
import { IPartnerProfile } from './shared.interface';

@Injectable()
export class SharedService{
    api: string;

    partner_info: BehaviorSubject<IPartnerProfile|null> = new BehaviorSubject(null);

    constructor(private http: HttpClient){
        this.api = (isDevMode()) ? DEV_API_URL : PROD_API_URL;
    }

    //Почему перестали удалять 0 - они должны участвовать в выборке метрик и соц сетях
    process_filter(filter) {
        Object.keys(filter).forEach((key) => {
            if (key.includes('FilterBlock')) {
            if (!filter[key]) delete filter[key.replace('FilterBlock', '')];
            delete filter[key];
            } else {
            if (Object.prototype.toString.call(filter[key]) == '[object Date]') {
                let _month = (<Date>filter[key]).getMonth()+1;
                let _day = (<Date>filter[key]).getDate();
                let _date = `${(<Date>filter[key]).getFullYear()}-${(_month < 10) ? '0'+_month.toString() : 
                _month.toString()}-${(_day < 10) ? '0'+_day.toString() : _day.toString()}T00:00:00.000Z`;
                filter[key] = _date;
            }
            if (filter[key] && typeof filter[key] === 'object') this.process_filter(filter[key]);
            if ((!filter[key] && filter[key] != 0) || filter[key] == null || filter[key] === false ||
            (typeof filter[key] === 'object' && !(filter[key] instanceof Date) && 
            Object.keys(filter[key]).length == 0)) delete filter[key];
            }
        });
        return filter;
    }

    get_filter_keys(filter): string[] {
        let keys: string[] = [];
        Object.keys(filter).forEach((key) => {
            keys.push(key);
            if (Object.prototype.toString.call(filter[key]) === '[object Object]') 
            keys = keys.concat(Object.keys(filter[key]));
        });
        return keys;
    }

    encodeB64(obj) {
        let stringToEncode: string;
        if (typeof obj === 'object'){
            stringToEncode = JSON.stringify(obj);
        } else if (typeof obj === 'string'){
            stringToEncode = obj;
        }
        if (stringToEncode.length > 0){
            return btoa(encodeURIComponent(stringToEncode).replace(
                /%([0-9A-F]{2})/g, (match, p1) => {
                    let code = `0x${p1}`;
                    return String.fromCharCode(+code);
                }
            ));
        }
    }

    get_columns_from_ls(prefix) {
        if (prefix && localStorage.getItem(`yoola_app:columns:${prefix}`))
        return localStorage.getItem(`yoola_app:columns:${prefix}`).split(';');
        else return false;
    }

    save_columns_to_ls(prefix, columns) {
        if (prefix && columns) localStorage.setItem(`yoola_app:columns:${prefix}`, columns.join(';'));
    }

    //Что бы не делать 2 запроса на получение информации о партнере, я делаю один метод
    //который заинициализируется во враппере профайла и дочерний компонент подписывается на него
    get_partner_info(id: string) {
        this.http.get<IPartnerProfile>(`${this.api}api/users/partners/${id}/`)
        .subscribe(result => {
          result.avatar = (result.avatar) ? result.avatar : '/assets/avatar-default.png';
          if (result.userinfo.login_as) {
            let pref = (isDevMode()) ? 'partner.dev.yoola.com' : 'yoola.app';
            result.userinfo.login_as['url'] = `https://${pref}/login-as?token=${result.userinfo.login_as.
            token}&version=${result.userinfo.login_as.app_version}&lang=${result.lang}`;
          }
          this.partner_info.next(result);    
        });
    }

    //Режет большие числа 1000000000 -> 1m
    short_number(num, fixed) {
        if (num === null) { return null; }
        if (num === 0) { return '0'; }

        let minus = (num < 0) ? -1 : 1;
        num = num * minus;

        fixed = (!fixed || fixed < 0) ? 0 : fixed;
        let b = (num).toPrecision(2).split("e"),
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
            c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed),
            d = c < 0 ? c : Math.abs(c),
            e = d + ['', 'k', 'm', 'b', 't'][k];
        
        return (minus < 0) ? `-${e}` : e;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/shared-service.service.ts